import { render } from "./StoreConfirmationModal.vue?vue&type=template&id=cc6d0cae"
import script from "./StoreConfirmationModal.vue?vue&type=script&lang=js"
export * from "./StoreConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__